import React, { useState, useEffect, useCallback, } from 'react';
import './templates.scss';
import { useNavigate } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import {getTemplateIds, } from '../../api/api'
import { useAuth } from '../../contexts/auth';
import List, { ItemDragging, MenuItem } from 'devextreme-react/list';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';

export default function Templates() {
  const { user, refreshSession } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [templates, setTemplates] = useState([]);

  const addTemplate = useCallback(() => {
    navigate('/template')
  }, [navigate])

  const onTemplateClick = useCallback((item) => {
    navigate('/template/'+item.itemData.template_id)
  }, [navigate])

  const onTemplateGenerateClick = useCallback((item) => {
    navigate('/generate/questions/'+item.itemData.template_id)
  }, [navigate])

  const onTemplateDataSuccess = useCallback((data) => {
    setTemplates(data);
    setLoading(false);
  }, [])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      setLoading(false);
      console.log(error);
    }
  }, [refreshSession]);

  useEffect(() => {
    if (user.signInUserSession) {
      getTemplateIds(user, onTemplateDataSuccess, onError)
    }
  }, [user, onTemplateDataSuccess, onError]);

  const onDragTemplatesStart = useCallback(
    (e) => {
      e.itemData = e.fromData === 'actualList'
        ? templates[e.fromIndex]
        : null;
    },
    [templates],
  );

  const onReorderTemplates = useCallback(
    (e) => {
      if (e.fromData === e.toData) {
        const updateTemplate = (q) => {
          const updatedQ = [...q];
          const [movedQ] = updatedQ.splice(e.fromIndex, 1);
          updatedQ.splice(e.toIndex, 0, movedQ);
          return updatedQ;
        };
        if (e.fromData === 'actualList') {
          setTemplates((prevTasks) => updateTemplate(prevTasks));
        }
      }
    },
    [],
  );

  return (
    <React.Fragment>
    {loading?
      <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
          <LoadIndicator
              id="large-indicator"
              height={60}
              width={60}
          />
      </div>
      :
      <>
      <div className="d-flex flex-row justify-content-between">
        <h2 className={''}>Templates</h2>
        <Button
            text="Add"
            icon="fas fa-plus"
            onClick={addTemplate}
        />
      </div>
      <hr/>

      <div className="dx-card">

        <List
          dataSource={templates}
          height={400}
          itemDeleteMode={"static"}
          displayExpr={"template_name"}
          onItemClick={onTemplateGenerateClick}
        >
          <ItemDragging
            allowReordering={true}
            group="tasks"
            data="actualList"
            onDragStart={onDragTemplatesStart}
            onReorder={onReorderTemplates}
          ></ItemDragging>
          <MenuItem
              text="Edit"
              action={onTemplateClick}
          />
          <MenuItem
              text="Delete"
              action={onTemplateClick}
          />
          <MenuItem
              text="Generate Document"
              action={onTemplateGenerateClick}
          />
        </List>
      </div>
      </>}
    </React.Fragment>
)}
